import React from "react";
import '../index.css'
import pdfFile from '../assets/Images/pdffile/valerion final catalog.pdf';
import img from '../assets/Images/download.png';

const Download = () => {
    return (
        <div className="container mb-3 text-center">
            <h3>Download Our PDF</h3>
             <img src={img} alt="img" className="img-fluid pdf-img mx-auto"/>
            <a href={pdfFile} target="_blank" rel="noopener noreferrer" download>
                <button className="d-flex mx-auto download mt-3">Download PDF</button>
            </a>
           
        </div>
    );
};

export default Download;
